"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_PRODUCT_MODAL = void 0;
var EDIT_PRODUCT_MODAL = {
  INPUT__QUANTITY: 'singleCreditNoteEditProductModal-input-quantity',
  INPUT__PRICE_PER_UNIT: 'singleCreditNoteEditProductModal-input-pricePerUnit',
  INPUT__BATCH_ID: 'singleCreditNoteEditProductModal-input-batchCode',
  INPUT__EXPIRY_DATE: 'singleCreditNoteEditProductModal-input-expiryDate',
  TEXTAREA__NOTE: 'singleCreditNoteEditProductModal-textarea-note',
  BUTTON__CANCEL: 'singleCreditNoteEditProductModal-button-cancel',
  BUTTON__SAVE: 'singleCreditNoteEditProductModal-button-save'
};
exports.EDIT_PRODUCT_MODAL = EDIT_PRODUCT_MODAL;